// posthog-js transport for the NON-Electron builds of the app (web +
// Capacitor iOS/Android), used by web-electron-shim.js and
// capacitor-shim.js. The Electron desktop path never loads this — its
// events go renderer → IPC → AnalyticsService (posthog-node).
//
// Events keep surface:'desktop' (it's the same app UI, so existing funnels
// keep working) and add a `platform` property ('web' | 'ios' | 'android')
// for splitting. Only active in production builds; dev keeps the
// console.debug behavior of the shims.

import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_Exh1Jo7ZzUE2y6cyKaCXOO3qzIvdKJVpK5mjlW6Am5y';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

const enabled = process.env.NODE_ENV === 'production';
let inited = false;

function client() {
    if (!enabled) return null;
    if (!inited) {
        inited = true;
        try {
            posthog.init(POSTHOG_KEY, {
                api_host: POSTHOG_HOST,
                autocapture: false,
                capture_pageview: false,
                persistence: 'localStorage',
            });
        } catch {
            return null;
        }
    }
    return posthog;
}

export function phTrack(platform, event, properties = {}) {
    try {
        client()?.capture(event, { surface: 'desktop', platform, ...properties });
    } catch { /* analytics must never break the app */ }
}

export function phIdentify(platform, userId, properties = {}) {
    try {
        if (userId) client()?.identify(String(userId), { platform, ...properties });
    } catch { /* ignore */ }
}

export function phSetPersonProperties(properties = {}) {
    try {
        client()?.setPersonProperties(properties);
    } catch { /* ignore */ }
}

export function phReset() {
    try {
        if (inited) client()?.reset();
    } catch { /* ignore */ }
}

// The shims are deliberately import-free scripts (Jest requires them raw in
// shim-parity.test.js), so they reach this transport through a window
// registration instead of an ES import. src/index.js imports this module
// before anything calls window.electron.analytics.*.
if (typeof window !== 'undefined') {
    window.__mixgoatPh = { phTrack, phIdentify, phSetPersonProperties, phReset };
}
